<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Plans API LyBox
                <span>Intégrez nos données immobilières dans vos outils</span>
            </h1>
        </div>

        <div class="col-12">
            <div class="message alert-success" *ngIf="success != ''">
                <i class="fa fa-check"></i>
                Votre abonnement API {{ success }} est validé.
            </div>
            <div class="message alert-danger" *ngIf="error != ''">
                <i class="fa fa-remove"></i>
                Le paiement a échoué, veuillez réessayer ou <a href="mailto:contact@lybox.fr">nous contacter</a>.
            </div>
        </div>

        <!-- Blocs forfait / paiement -->
        <div class="col-lg-12">
            <div class="row">
                <div class="col-md-6">
                    <!-- Forfait API actif -->
                    <div class="bloc-info row"
                         *ngIf="user.api_plan != '' && user.subscription_api.status != 'past_due'">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait API <b>{{ getPlanLabel() }}</b>
                                <span class="fs-4"
                                      *ngIf="user.subscription_api?.cancel_date && user.subscription_api.cancel_date != '01/01/0001' && user.subscription_api.cancel_date != '01/01/1970'">
                                    Votre abonnement sera résilié le {{ user.subscription_api.cancel_date }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <a *ngIf="!user.subscription_api?.cancel_date || user.subscription_api.cancel_date == '01/01/0001' || user.subscription_api.cancel_date == '01/01/1970'"
                               (click)="cancelApiPlan()"
                               class="btn btn-ghost btn-lg d-block">Résilier</a>
                        </div>
                        <div class="col-md-6 col-12">
                        </div>
                    </div>

                    <!-- Paiement échoué -->
                    <div class="bloc-info row"
                         *ngIf="user.subscription_api.status == 'past_due'">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait API <b>{{ getPlanLabel() }}</b>
                                <span class="fs-4 text-red">
                                    Le renouvellement de votre abonnement a échoué et vos accès ont été désactivés
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <a href="mailto:contact@lybox.fr?subject=Erreur de paiement API"
                               class="btn btn-lg btn-outline d-block">Contactez-nous</a>
                        </div>
                        <div class="col-md-6 col-12">
                            <a (click)="updateCB()" *ngIf="user.payment_method.type != ''"
                               class="btn btn-lg btn-danger float-right d-block">Modifier mon moyen de paiement</a>
                        </div>
                    </div>

                    <!-- Aucun forfait API -->
                    <div class="bloc-info row"
                         *ngIf="user.api_plan == ''">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Aucun forfait API en cours
                            </div>
                        </div>
                        <div class="col-md-6 col-12 fs-2 offers">
                        </div>
                        <div class="col-md-6 col-12">
                            <a (click)="scrollToPlan()"
                               class="btn btn-lg d-block">Choisir un forfait API</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="bloc-info row">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-card bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Moyen de paiement
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="infoCb">
                                <a (click)="updateCB()" *ngIf="user.payment_method.type != ''"
                                   class="btn btn-lg btn-outline float-right">Modifier</a>

                                <b class="fs-4" *ngIf="user.payment_method.type == ''">
                                    Aucun moyen de paiement enregistré<br/><br/>
                                </b>

                                <b class="fs-4" *ngIf="user.payment_method.type == 'sepa_debit'">
                                    Prélèvement bancaire<br/>
                                </b>
                                <b class="fs-4" *ngIf="user.payment_method.type == 'card'">
                                    {{ user.payment_method.type_detail | titlecase }} {{ user.payment_method.last_4 }}
                                    <br/>
                                    Expire en {{ user.payment_method.exp_month }}/{{ user.payment_method.exp_year }}
                                </b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Plans -->
        <div class="col-12 position-relative mt-4">
            <a [routerLink]="['/app/user/plan-pro']" class="text-center ps-0 see_part">
                <i class="fa fa-arrow-circle-o-left"></i><br/>
                Voir les offres professionnelles
            </a>
            <div id="plan" class="row d-flex justify-content-center align-items-stretch pricing">
                <div class="col-plan" *ngFor="let plan of plans">
                    <div class="pricing-light">
                        <h2 [class]="plan.color + ' pb-2'">{{ plan.name }}</h2>
                        <b class="price">
                            {{ plan.price }} €<span class="fs-5"> HT /mois</span>
                        </b>
                        <p class="credits-included">
                            <b>{{ plan.credits | number }}</b> crédits /mois
                        </p>
                        <p class="price-per-credit">
                            soit {{ plan.pricePerCredit }} € / crédit
                        </p>
                        <a class="btn btn-primary mb-2"
                           *ngIf="user.api_plan == ''"
                           (click)="planSelect(plan.id)">
                            <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                            <span [hidden]="loading">Choisir ce plan</span>
                        </a>
                        <p class="btn btn-disabled mb-2 text-primary"
                           *ngIf="user.api_plan == plan.id">
                            <i class="fa fa-check me-1"></i> Plan actuel
                        </p>
                        <a class="btn btn-outline-primary btn-small mt-0" href="https://api.lybox.fr/api/doc" target="_blank">
                            Documentation API
                        </a>
                        <ul class="pricing-features">
                            <li>Recherche d'annonces (1 500+ sources)
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Recherchez parmi 1 500+ sources immobilières en temps réel via /api/ad/search"></i>
                            </li>
                            <li>Analyse par URL
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Analysez n'importe quelle annonce immobilière par son URL via /api/ad/url"></i>
                            </li>
                            <li>Data des villes
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Prix immobilier, loyers, données sociodémographiques pour chaque commune de France via /api/city/{{ '{' }}city_code{{ '}' }}"></i>
                            </li>
                            <li class="text-grey">Alertes Webhook
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Bientôt disponible — Recevez les nouvelles annonces en temps réel via webhook"></i>
                            </li>
                            <li>Support prioritaire</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pack de crédits -->
        <div class="col-12 text-center mt-4 mb-2">
            <div class="pack-inline">
                <span class="pack-inline-label">Pack de 1 000 crédits supplémentaires :</span>
                <b class="pack-inline-price">{{ getPackPrice() }} € HT</b>
                <a class="btn btn-primary btn-sm ms-3" (click)="buyPack()">
                    <mat-spinner diameter="20" [hidden]="!loading"></mat-spinner>
                    <span [hidden]="loading">Acheter un pack</span>
                </a>
            </div>
        </div>

        <div class="col-12 text-center mt-2 mb-5">
            <p class="text-grey">
                Besoin de plus de volume ? <a href="mailto:contact@lybox.fr?subject=Plan API Entreprise">Contactez-nous</a> pour un plan Entreprise sur mesure.
            </p>
        </div>

        <!-- Système de crédits -->
        <div class="col-12 mt-2">
            <div class="card block isMinimizable">
                <div class="card-header">
                    <div class="card-title">
                        <i class="fa fa-angle-up"></i>
                        <h2>Comment fonctionnent les crédits ?</h2>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="row">
                        <div class="col-lg-6 mb-4">
                            <p class="credit-explain-text">
                                Chaque requête sur les endpoints <code>/api/ad/url</code> et <code>/api/ad/search</code>
                                consomme des crédits en fonction des données demandées.
                                Vous composez votre requête en ajoutant les modules de données dont vous avez besoin.
                            </p>
                            <p class="mt-3 mb-1"><b>Exemple :</b></p>
                            <div class="credit-example">
                                <code>/api/ad/url?url=...&calc&city_prix</code>
                                <div class="credit-example-detail">
                                    <span>ad (annonce) = 1 crédit</span>
                                    <span>+ calc (rentabilité) = 7 crédits</span>
                                    <span>+ city_prix = 5 crédits</span>
                                    <span class="total">= <b>13 crédits</b></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <p class="mb-2"><b>Endpoints /api/ad/url et /api/ad/search</b></p>
                            <table class="table table-striped credit-table">
                                <thead>
                                <tr>
                                    <th>Module de données</th>
                                    <th class="text-center">Crédits</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let credit of creditCostsAd">
                                    <td>{{ credit.name }}</td>
                                    <td class="text-center"><b>{{ credit.cost == 1 ? credit.cost + ' crédit' : '+' + credit.cost + ' crédits' }}</b></td>
                                </tr>
                                <tr>
                                    <td><b>Coût maximum par requête</b></td>
                                    <td class="text-center"><b>23 crédits</b></td>
                                </tr>
                                </tbody>
                            </table>

                            <p class="mt-4 mb-2"><b>Endpoint /api/city/{{ '{' }}city_code{{ '}' }}</b></p>
                            <table class="table table-striped credit-table">
                                <thead>
                                <tr>
                                    <th>Module de données</th>
                                    <th class="text-center">Crédits</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let credit of creditCostsCity">
                                    <td>{{ credit.name }}</td>
                                    <td class="text-center"><b>{{ credit.cost }} crédits</b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
